import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {AnalyzeFormulaUpdateElementType} from "../interface";
import {updateFormula} from "../../../../../api/inventory/AnalyzeApi";

export const useUpdateFormula = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: AnalyzeFormulaUpdateElementType[]) => updateFormula(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "수정되었습니다.",
                type: "alert",
                closeAction: () => {
                    qc.invalidateQueries({queryKey: ["readInventoryAnalysis"]});
                    qc.invalidateQueries({queryKey: ["readFormula"]});
                }
            });
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
